import React, { useState } from 'react';
import { MdArrowBack, MdClose, MdChevronRight, MdVerified } from 'react-icons/md';
import './dialogs.css';
import EnquiryDialog from './EnquiryDialog';
import architectProfileImg from '../../../assets/architect-profile.png';
import projectImg1 from '../../../assets/project-img-1.jpg';
import projectImg2 from '../../../assets/project-img-2.jpg';
import projectImg3 from '../../../assets/project-img-3.jpg';

const PROJECT_IMAGES = [projectImg1, projectImg2, projectImg3];

export const DUMMY_PROJECTS = [
  { id: 1, code: 'NYL1299-KEN', name: 'Ruiru Mixed-Use Development', status: 'Ongoing', location: 'Ruiru, Kenya', company: 'Apex Developments Ltd' },
  { id: 2, code: 'TKR4821-KEN', name: 'Thika Road Offices', status: 'Completed', location: 'Nairobi, Kenya', company: 'Greenfield Properties' },
  { id: 3, code: 'WTL3374-KEN', name: 'Westlands Tower', status: 'Completed', location: 'Westlands, Nairobi', company: 'Skyline Group' },
  { id: 4, code: 'KRN5510-KEN', name: 'Karen Residential Estate', status: 'Ongoing', location: 'Karen, Nairobi', company: 'Sable Homes Kenya' },
  { id: 5, code: 'MBR7762-KEN', name: 'Mombasa Road Logistics Hub', status: 'Completed', location: 'Syokimau, Nairobi', company: 'TransAfrica Logistics' },
  { id: 6, code: 'UPH2293-KEN', name: 'Upperhill Medical Centre', status: 'Ongoing', location: 'Upperhill, Nairobi', company: 'Medicore Facilities' },
  { id: 7, code: 'KSM8841-KEN', name: 'Kisumu Lakefront Plaza', status: 'Completed', location: 'Kisumu, Kenya', company: 'Lakeview Ventures' },
].map((p, i) => ({ ...p, image: PROJECT_IMAGES[i % PROJECT_IMAGES.length] }));

const ArchitectProfileDialog = ({
  isOpen,
  onClose,
  onBack,
  architect,
  onEnquire,
  onProjectEnquire,
}) => {
  const [enquiryOpen, setEnquiryOpen] = useState(false);
  const [enquiryProject, setEnquiryProject] = useState(null);

  if (!isOpen || !architect) return null;

  const openEnquiry = (project = null) => {
    setEnquiryProject(project);
    setEnquiryOpen(true);
  };

  const { name, avatar, location, title, regNo, featuredProjects } = architect;
  const projects = featuredProjects?.length ? featuredProjects : DUMMY_PROJECTS;

  const stats = {
    total: projects.length,
    completed: projects.filter(p => p.status === 'Completed').length,
    ongoing: projects.filter(p => p.status === 'Ongoing').length,
  };

  const initials = name
    ? name.trim().split(' ').filter(Boolean).slice(0, 2).map(p => p[0]?.toUpperCase() || '').join('')
    : 'AR';

  return (
    <>
      <div className="ap-overlay" onClick={onClose}>
        <div className="ap-panel" onClick={e => e.stopPropagation()}>
          <div className="ap-header">
            <button className="ap-icon-btn" onClick={onBack ?? onClose} aria-label="Back">
              <MdArrowBack size={20} />
            </button>
            <span className="ap-header-title">Back</span>
            <button className="ap-icon-btn ap-close-btn" onClick={onClose} aria-label="Close">
              <MdClose size={20} />
            </button>
          </div>

          <div className="ap-profile-row">
            <img
              src={avatar || architectProfileImg}
              alt={name}
              className="ap-avatar"
              onError={e => { e.target.src = architectProfileImg; }}
            />
            <div className="ap-profile-info">
              <div className="ap-name-row">
                <span className="ap-name">Arch. {name}</span>
                <MdVerified className="ap-verified" size={16} />
              </div>
              {location && <span className="ap-location">{location}</span>}
              {(title || regNo) && (
                <span className="ap-title">
                  {[title, regNo && `Arch Reg. #${regNo}`].filter(Boolean).join(' · ')}
                </span>
              )}
            </div>
          </div>

          <button className="ap-enquire-btn" onClick={() => openEnquiry()}>
            Enquire about a Project
            <MdChevronRight size={18} />
          </button>

          <div className="ap-stats-row">
            {[
              { count: stats.total, label: 'Projects', highlight: true },
              { count: stats.completed, label: 'Completed', highlight: true },
              { count: stats.ongoing, label: 'Ongoing', highlight: true },
            ].map((s, i) => (
              <div key={i} className={`ap-stat-item${s.highlight ? ' ap-stat-item--highlight' : ''}`}>
                <span className="ap-stat-count">{s.count}</span>
                <span className="ap-stat-label">{s.label}</span>
              </div>
            ))}
          </div>

          <div className="ap-featured-section">
            <div className="ap-featured-header">
              <span className="ap-section-title">Featured Projects</span>
              <button className="ap-tap-enquire" onClick={() => openEnquiry()}>Tap to enquire</button>
            </div>
            <ul className="ap-projects-list">
              {projects.map((project, i) => (
                <li key={project.id ?? i} className="ap-project-item" onClick={() => openEnquiry(project)}>
                  {project.image ? (
                    <img src={project.image} alt={project.name} className="ap-project-thumb" onError={e => { e.target.style.display = 'none'; }} />
                  ) : (
                    <div className="ap-project-thumb ap-project-thumb-fallback" />
                  )}
                  <div className="ap-project-meta">
                    {project.code && <span className="ap-project-code">{project.code}</span>}
                    <span className="ap-project-name">{project.name}</span>
                    {project.status && <span className="ap-project-status">{project.status}</span>}
                    {project.location && <span className="ap-project-location">{project.location}</span>}
                  </div>
                  <MdChevronRight className="ap-project-chevron" size={20} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <EnquiryDialog
        isOpen={enquiryOpen}
        onClose={() => setEnquiryOpen(false)}
        onBack={() => setEnquiryOpen(false)}
        project={enquiryProject}
        onSend={async (data) => {
          await onEnquire?.(data);
          setEnquiryOpen(false);
        }}
      />
    </>
  );
};

export default ArchitectProfileDialog;
